export const DATE_FORMAT = {
  DD: 'dd',
  MMM: 'MMM',
  YYYY: 'yyyy',
  HH_MM_FORMAT: 'HH:mm',
  HH_MM_SS_FORMAT: 'HH:mm:ss',
  MMM_DD_FORMAT: 'MMM dd',
  MMM_DD_YYYY: 'MMM dd, yyyy',
  MMM_DD_YYYY_FORMAT: 'MMM dd, yyyy',
  MMM_DD_NUMBER_YYYY_FORMAT: 'MMM DD, yyyy',
  DD_MMM_YYYY_FORMAT: 'dd MMM, yyyy',
  DD_MMM_YY_FORMAT: 'dd MMM, yy',
  DD_MMMM_YYYY_FORMAT: 'dd MMMM, yyyy',
  MMM_DD_YY_HH_MM_SS: 'MMM dd, yy HH:mm:ss',
  MMM_DD_YY_HH_MM: 'MMM dd, yy HH:mm',
  MMM_DD_YYYY_HH_MM_SS: 'MMM dd, yyyy HH:mm:ss',
  MMM_DD_YYYY_HH_MM_FORMAT: 'MMM dd, yyyy HH:mm',
  MMMM_DD_YYYY_FORMAT: 'MMMM dd, yyyy',
  MMMM_DD_YY_FORMAT: 'MMMM dd, yy',
  MMMM_YYYY_FORMAT: 'MMMM yyyy',
  MMM_YYYY_FORMAT: 'MMM yyyy',
  Q_YYYY_FORMAT: 'Q yyyy',
  Q_YY_FORMAT: 'Q yy',
  LLL_YY_FORMAT: 'LLL yy',
  MMM_YY_FORMAT: 'MMM yy',
  YYYYMMDD: 'yyyy-MM-dd',
  MMM_DD_YYYY_HH_MM: 'MMM dd, yyyy | HH:mm',
  MMM_DD_YYYY_MIDDOT_HH_MM: 'MMM dd, yyyy · HH:mm',
  DD_MM_YYYY: 'dd.MM.yyyy',
  DDMMYYYY: 'DD-MM-YYYY',
  DD_MMM: 'dd/MMM',
  YYYY_MM_DD_T_HH_MM_SS_SSS_Z: "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"
};
